
define('text!TescoMobile_Checkout/template/cart/order-cancelled.html',[],function () { return '<!-- ko if: message --><div class="message error"><div><span data-bind="text: message"></span></div></div><!-- /ko -->';});

